import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import type {BaseVectorRoundnessOptionProps} from './base-vector-roundness-option.types';

const VECTOR_COLOR_ROUNDNESS_MIN = 0;
const VECTOR_COLOR_ROUNDNESS_MAX = 100;

export function BaseVectorRoundnessOption({className = '', ...props}: BaseVectorRoundnessOptionProps): ReactElement<any> {
  return (
    <ContextualMenuSliderOptions
      id="vector-color-roundness-option"
      className={className}
      value={props.fillRoundness}
      label={window.i18next.t('pmwjs_roundness')}
      range={{
        min: VECTOR_COLOR_ROUNDNESS_MIN,
        max: VECTOR_COLOR_ROUNDNESS_MAX,
      }}
      transformDisplay={{
        min: VECTOR_COLOR_ROUNDNESS_MIN,
        max: VECTOR_COLOR_ROUNDNESS_MAX,
      }}
      onChange={(updatedValue: number): void => {
        props.onChangeRoundness(updatedValue, false);
      }}
      onChangeEnded={(updatedValue: number): void => {
        props.onChangeRoundness(updatedValue, true);
      }}
    />
  );
}
